$(document).ready(function(){
	onloadmethod();		
	
	/*Menu*/
	$(".top-menu ul ul").parent().find('a:first').append('<span class="dropdown"></span>')
	$(".gn-icon-menu").click(function(e) {
		e.stopPropagation();
	  $(this).toggleClass("on");  
	});	
	$('#menu').click(function(e) {	
		e.stopPropagation();
		if ($('#slidingMenu').hasClass('open')){		
			$('#slidingMenu').removeClass('open');
			$('#slidingMenu').animate({
				right: '-245px'
			}, 500); 
		} else {
			$('#slidingMenu').addClass('open');
			$('#slidingMenu').animate({
				right: '0px'
			}, 500);
		  }
	});
	


	//Popup	
	$(".fancybox").fancybox({
		padding:0
	})
	
	

	if ( $.fn.carouFredSel ){
		$("#HomeSliderDesktop").carouFredSel({
			responsive	: true,		
			pagination: "#hspager",
			scroll		: {
				fx			: "crossfade",
				easing		: "swing",
				timeoutDuration: 5000,
				duration	: 1000

			},
			items		: {
				visible		: 1,
				height		: "24.47%"
			}
		});

	

	if($('#gcc_carousel').length>0){
		$('#gcc_carousel').carouFredSel({
			auto: false,	
			circular: false,
			infinite: false,
			scroll: 1,
			prev: '#gcc-prev',
			next: '#gcc-next',
			width: '100%',
			items: {
				height: 300,
				width:249
			}
		});
	}
	}
  
	if ($(".con .my-state-dropdown").length > 0) {
		$('.con .my-state-dropdown').each(function(){
			$(this).sSelect({ ddMaxHeight: '300px', divtextClass: 'selectedTxt', containerClass: 'newListSelected show-if-states-founddm siz1' })
			});		
	}

	$(document).on("click", "button.backStep", function () {
		var curStep = $("#orderNav").attr("data-value");
		if (!curStep) curStep = 1;
		var prevStep = parseInt(curStep) - 1;
		if (prevStep < 0) prevStep = 1;
		setNavigation(prevStep);
	});
	$(document).on("click", "input.nextstep", function () {
		var curStep = $("#orderNav").attr("data-value");
		if (!curStep) curStep = 1;
		ValidateAndGoNext(curStep);
	});	
	
		

$(".help-container").on("click", ".help-icon", function(e) {
  $(this).siblings(".help-text").toggle();
});

});


export function  trapFocus(elem) {
    var tabbable = elem.find('select, input:visible, textarea, button, a, .modal-element');
    
    var firstTabbable = tabbable.first();
    var lastTabbable = tabbable.last();
    /*set focus on first input*/
    firstTabbable.focus();

    /*redirect last tab to first input*/
    lastTabbable.on('keydown', function (e) {
       if ((e.which === 9 && !e.shiftKey)) {
           e.preventDefault();
           firstTabbable.focus();
       }
    });

    /*redirect first shift+tab to last input*/
    firstTabbable.on('keydown', function (e) {
        if ((e.which === 9 && e.shiftKey)) {
            e.preventDefault();
            lastTabbable.focus();
        }
    });
    
    /* allow escape key to close insiders div */
    elem.on('keyup', function(e){
      if (e.keyCode === 27 ) {
        elem.hide();
      };
    });
  };


$(window).resize(function(){	
	onloadmethod();	
});

function onloadmethod(){
	
}


